import axios from 'axios';

export default class AssetsIntelligenceServices {
  getAssets(args?: string) {
    // process.env.REACT_APP_API_GLOBAL_URL + `asset-hierarchy/asset?where=`+args;
    let theData =
      process.env.REACT_APP_API_GLOBAL_URL + `asset-hierarchy/asset?where=`+args;
    return axios.get(theData);
  }
  AddAssets(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.post(
      process.env.REACT_APP_API_GLOBAL_URL + `asset-hierarchy/assets/create`,
      obj,
      { headers }
    );
  }

  EditAssets(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.post(
      process.env.REACT_APP_API_GLOBAL_URL + `asset-hierarchy/assets/edit`,
      obj,
      { headers }
    );
  }

  DeleteAssets(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.post(
      process.env.REACT_APP_API_GLOBAL_URL + `asset-hierarchy/assets/delete`,
      obj,
      { headers }
    );
  }
}
